import { Route } from 'react-router-dom';
import { PRODUCTION_PATH } from './api/prodstats';
import { ProductionPage } from './pages/Production';

/** Production statistics' route. */
export function productionRoutes(allowed: (path: string) => boolean, scopes: readonly string[]) {
  if (!allowed(PRODUCTION_PATH)) return [];
  return [
    <Route key={PRODUCTION_PATH} path={PRODUCTION_PATH} element={<ProductionPage scopes={scopes} />} />,
  ];
}
